// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__k_VjF","detailsBorder":"styles_detailsBorder__-Dujt"};